import React from 'react';
import { Button } from '@punchcard/core';

interface SymbolsScrollableContentProps {
	scrollContainerRef: React.RefObject<HTMLDivElement>;
	handleScroll: () => void;
	isLoadingAllSymbols: boolean;
	filteredSymbolsData: SymbolCategoryDTO[];
	categoryRefs: React.MutableRefObject<{ [key: number]: HTMLDivElement | null }>;
	onSymbolSelect: (symbol: string) => void;
}

const SymbolsScrollableContent: React.FC<SymbolsScrollableContentProps> = ({
	scrollContainerRef,
	handleScroll,
	isLoadingAllSymbols,
	filteredSymbolsData,
	categoryRefs,
	onSymbolSelect
}) => {
	return (
		<div
			ref={scrollContainerRef}
			className="symbols-modal__content my-1"
			onScroll={handleScroll}
		>
			{isLoadingAllSymbols ? (
				<div className="d-flex justify-content-center align-items-center symbols-modal__loading-container">
					<span>Loading symbols...</span>
				</div>
			) :
				filteredSymbolsData && filteredSymbolsData.length > 0 ? (
					<div>
						{filteredSymbolsData.map((category, index) => (
							<div
								key={category.id}
								ref={(el) => {
									categoryRefs.current[category.id] = el;
								}}
							>
								{index > 0 && <hr className="flex-grow-1 w-100 my-1" />}

								{/* Symbols Grid */}
								<div className="row px-3">
									{category.symbols.map((symbol: SymbolDTO) => (
										<div key={symbol.id} className="col-2">
											<Button
												className="btn btn-ghost w-100 d-flex justify-content-center align-items-center border-0 symbols-modal__symbol-button"
												onClick={(e) => {
													e.preventDefault();
													e.stopPropagation();
													onSymbolSelect(symbol.symbolChar);
												}}
												title={symbol.description}
											>
												<span className="symbols-text">{symbol.symbolChar}</span>
											</Button>
										</div>
									))}
								</div>
							</div>
						))}
					</div>
				) : (
					<div className="d-flex justify-content-center align-items-center symbols-modal__no-symbols">
						<span className="text-muted">No symbols available</span>
					</div>
				)}
		</div>
	);
};

export default SymbolsScrollableContent;
